var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('ScoreBoard',{staticClass:"app__scoreboard"}),_c('router-view'),_c('button',{on:{"click":_vm.deleteProgress}},[_vm._v("Delete Progress")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }